import { create } from 'zustand';
import { PRD5030_R01ResultDto } from './Dto_PRD5030_R01';

export interface PRD5030_R01Filter {
	compCd: string;
	year: number;          // 조회 연도
	workplaceCd: string;   // 공정
	itemGroup: string;     // 품목그룹
	itemCd: string;        // 품목코드(선택)
	itemNm: string;        // 품목명(팝업 표시용, 선택)
}

export interface Store_PRD5030_R01 {
	PRD5030_R01Filter: PRD5030_R01Filter;
	setPRD5030_R01Filter: (filter: Partial<PRD5030_R01Filter>) => void;

	// 결과: 월별 12행 단일 배열
	PRD5030_R01List: PRD5030_R01ResultDto[];
	setPRD5030_R01List: (list: PRD5030_R01ResultDto[]) => void;

	initData: () => void;
}

export const defaultPRD5030_R01Filter: PRD5030_R01Filter = {
	compCd: '',
	year: new Date().getFullYear(),
	workplaceCd: '',
	itemGroup: '',
	itemCd: '',
	itemNm: '',
};

export const usePRD5030_R01Store = create<Store_PRD5030_R01>((set) => ({
	PRD5030_R01Filter: defaultPRD5030_R01Filter,
	setPRD5030_R01Filter: (filter) => set((state) => ({
		PRD5030_R01Filter: { ...state.PRD5030_R01Filter, ...filter },
	})),

	PRD5030_R01List: [],
	setPRD5030_R01List: (list) => set({ PRD5030_R01List: list }),

	initData: () => set({
		PRD5030_R01Filter: defaultPRD5030_R01Filter,
		PRD5030_R01List: [],
	}),
}));
